<template>
    <div ref="wrapper" :class="theme.wrapper" @click.stop>
        <div :class="theme.close" @click="$emit('close')">
            <span class="fa-solid fa-times"></span>
        </div>
        <div :class="theme.header">Filters</div>
        <div :class="theme.filters">
            <div v-for="filter in filters" :key="`filter-${filter.name}`">
                <div v-if="filter.show_divider" :class="theme.divider"></div>

                <app-check-list-filter
                    v-if="filter.type === 'list' && filter.checklist"
                    :data="data"
                    :filter="filter"
                />
                <app-select-list-filter
                    v-else-if="filter.type === 'list'"
                    :data="data"
                    :filter="filter"
                />
                <app-date-filter
                    v-else-if="filter.type === 'date'"
                    :data="data"
                    :filter="filter"
                />
            </div>
        </div>
        <div :class="theme.footer">
            <button type="button" class="btn btn-default" @click="clear">
                Reset
            </button>
        </div>
    </div>
</template>

<script>
import SelectListFilter from './SelectListFilter.vue';
import CheckListFilter from './CheckListFilter.vue';
import DateFilter from './DateFilter.vue';
import Common from './mixins/Common.vue';

export default {
    components: {
        'app-select-list-filter': SelectListFilter,
        'app-check-list-filter': CheckListFilter,
        'app-date-filter': DateFilter,
    },
    mixins: [Common],
    props: {
        data: Object,
        filters: Array,
    },
    mounted() {
        $(this.$refs.wrapper).draggable();
    },
    methods: {
        clear() {
            this.filters.forEach(x => (x.current_value = x.default_value));
            this.bus.$emit('filter-changed');
            this.$emit('close');
        },
    },
};
</script>

<style lang="scss" module></style>
<style
    lang="scss"
    module="theme_default"
    src="./../css/themes/default/filter_menu.scss"
></style>
<style
    lang="scss"
    module="theme_simple"
    src="./../css/themes/simple/filter_menu.scss"
></style>
